// Query Example:

import { useQuery } from "@apollo/client";


const useQueryUserLanguages = ( query ) => {

  const { loading, error, data } = useQuery(query, {
    variables: {
      languagesStatus: true
    },
    // fetchPolicy: 'cache-only'
  });

  return {
    loadingQuery: loading,
    errorQuery: error,
    dataQuery: !!data && data.languages,
  }
};

export default useQueryUserLanguages;